<template>
  <div class="grey lighten-2"
       style="width: 230px; position: relative;">
    <div class="d-flex flex-column fill-height flex-grow-1 justify-center align-center">
      <v-menu v-if="canBePresented && canBeOpened"
              offset-y>
        <template v-slot:activator="{on, attrs}">
          <v-img v-if="presentation.thumbnail && presentation.thumbnail.url"
                 :src="presentation.thumbnail.url"
                 width="230"
                 height="106"
                 contain
                 alt="Thumbnail"
                 v-bind="attrs"
                 v-on="on">
          </v-img>
          <div v-else
               v-bind="attrs"
               v-on="on"
               style="width: 230px; height: 106px">
            &nbsp;
          </div>
        </template>
        <open-presentation-menu-list :presentation="presentation">
        </open-presentation-menu-list>
      </v-menu>
      <v-img v-else-if="presentation.thumbnail && presentation.thumbnail.url"
             :src="presentation.thumbnail.url"
             width="230"
             contain
             alt="Thumbnail">
      </v-img>
      <div v-else
           style="width: 230px; height: 106px;">
        &nbsp;
      </div>
    </div>
    <v-tooltip v-if="presentation.owner_id === user.id"
               top>
      <template v-slot:activator="{on, attrs}">
        <v-icon color="black"
                class="white pa-1"
                style="position: absolute; right: 4px; top: 4px;"
                v-bind="attrs"
                v-on="on">
          fal fa-user-lock
        </v-icon>
      </template>
      <div>
        This is private to you.
      </div>
    </v-tooltip>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import OpenPresentationMenuList from "./OpenPresentationMenuList";
import PresentationCardActions from "./PresentationCardActions";

export default {
  components: {PresentationCardActions, OpenPresentationMenuList},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    ...mapGetters('content', [
      'bookmarks',
      'bookmarkedPresentations',
      'liveMode',
    ]),
    canBePresented() {
      return !!this.presentation.settings.can_be_presented_by_user;
    },
    canBeOpened() {
      if (this.isHTML) { // MLD-2254
        return this.team.is_content_domain_enabled
          && this.presentation.settings.can_user_use_cdn;
      }
      return !this.isHTML;
    },
    isURL() {
      return this.presentation.type_url;
    },
    isHTML() {
      return this.presentation.type_html;
    },
  },
  methods: {}
}
</script>
